export const BaseUrl = process.env.NODE_ENV === "production"
    ? `https://${location.host}`
    : `https://${location.hostname}:9000`;
export default class BaseClient {
    getBaseUrl(bo: string, url?: string) {
        return BaseUrl;
    }
    async transformOptions(request: RequestInit) {
        request.headers = new Headers({
            "Content-Type": "application/json",
            "Accept": "application/json",
            'charset': 'utf8',
            "Cm-Version": require("../package.json").version,
        });
        request.credentials = "include";
        request.mode = "cors";
        return request;
    }
}